export interface Strings {
  title: string;
  emptyHeading: string;
  emptySub: string;
  placeholder: string;
  loading: string;
  errorGeneric: string;
  errorNetwork: string;
  errorMissingKey: string;
  open: string;
  close: string;
  send: string;
  suggestions: string[];
}

const en: Strings = {
  title: "AI Sommelier",
  emptyHeading: "How may I assist your cellar today?",
  emptySub: "Ask about investments, tasting notes, or pairings.",
  placeholder: "Inquire about a vintage…",
  loading: "Decanting insights…",
  errorGeneric: "Something went wrong. Please try again.",
  errorNetwork: "Couldn't reach the wine intelligence service.",
  errorMissingKey: "This widget is missing an API key.",
  open: "Open MrWine chat",
  close: "Close chat",
  send: "Send message",
  suggestions: [
    "Tell me about Château Pétrus 2015",
    "Best Burgundy under $200?",
    "What's the investment potential of Opus One?",
  ],
};

const fr: Strings = {
  title: "AI Sommelier",
  emptyHeading: "Comment puis-je servir votre cave aujourd'hui ?",
  emptySub: "Posez une question sur les investissements, les notes de dégustation ou les accords.",
  placeholder: "Renseignez-vous sur un millésime…",
  loading: "Décantation des analyses…",
  errorGeneric: "Une erreur est survenue. Veuillez réessayer.",
  errorNetwork: "Impossible de joindre le service d'intelligence vinicole.",
  errorMissingKey: "Ce widget n'a pas de clé API.",
  open: "Ouvrir le chat MrWine",
  close: "Fermer le chat",
  send: "Envoyer",
  suggestions: [
    "Parlez-moi du Château Pétrus 2015",
    "Meilleur Bourgogne à moins de 200 € ?",
    "Quel est le potentiel d'investissement de l'Opus One ?",
  ],
};

const es: Strings = {
  title: "AI Sommelier",
  emptyHeading: "¿En qué puedo ayudar con su bodega hoy?",
  emptySub: "Pregunte sobre inversiones, notas de cata o maridajes.",
  placeholder: "Consulte sobre una añada…",
  loading: "Decantando información…",
  errorGeneric: "Algo salió mal. Vuelva a intentarlo.",
  errorNetwork: "No se pudo conectar con el servicio.",
  errorMissingKey: "Falta la clave de API en este widget.",
  open: "Abrir chat de MrWine",
  close: "Cerrar chat",
  send: "Enviar",
  suggestions: [
    "Háblame del Château Pétrus 2015",
    "¿Mejor Borgoña por menos de 200 €?",
    "¿Potencial de inversión de Opus One?",
  ],
};

const dictionaries: Record<string, Strings> = { en, fr, es };

export function getStrings(lang: string): Strings {
  const code = lang.toLowerCase().split("-")[0];
  return dictionaries[code] ?? en;
}
